import Tooltip from 'primevue/tooltip';

export default [
  {
    name: 'tooltip',
    directive: Tooltip,
  }
]